
import React, { useEffect, useState } from "react";
import "../../../styles/widgets/widgets.css";
import "../../../styles/groups/account.css";
import { LocationSelector, ProvinceSelector } from "../form";
import { Dropdown } from "../input";
import { listRoleOptions } from "../../../misc/account";
import { Blocker } from "../misc";
import { LoadingAnimation } from "../loading";

/**
 * 
 * @param {{ id, name, category, lgu }} attraction 
 * @param {{ lgu }} defaults 
 * @param {{ lgu, province }} collection 
 */
export function AccountFactory({ account, collection, onChange, controller = {} }) {
    const modifying = account ? true : false;
    account = account ? { ...account } : { fullname: "", username: "", role: "lgu", role_specific: "1" };

    const { fullname, username, contact, email, role, role_specific } = account;
    const refs = {
        fullname: React.createRef(),
        email: React.createRef(),
        contact: React.createRef(),
        username: React.createRef(),
        password: React.createRef(),
        confirmPassword: React.createRef(),
    };

    const [ error, setError ] = useState(null);
    const [ saving, setSaving ] = useState(false);
    const [ currentLGU, setLGU ] = useState(account.role === "lgu" ? account.role_specific : "1");
    const [ currentProvince, setProvince ] = useState(account.role === "province" ? account.role_specific : "1");
    const [ currentRole, setCurrentRole ] = useState(role);
    const [ currentRoleSpecific, setCurrentRoleSpecific ] = useState(role_specific);

    controller.setError = (error) => {
        setSaving(false);
        setError(error);
    };

    controller.setSaving = (saving) => {
        setError(null);
        setSaving(saving);
    };

    const roleOptions = listRoleOptions();

    const update = (attrs) => {
        onChange({ 
            fullname: refs.fullname.current?.value || "",
            email: refs.email.current?.value || "",
            contact: refs.contact.current?.value || "",
            username: refs.username.current?.value || "",
            password: refs.password.current?.value || "",
            confirmPassword: refs.confirmPassword.current?.value || "",
            ...attrs
        });
    };

    useEffect(() => {
        update({ role: { label: currentRole, lgu: currentLGU, province: currentProvince } });
    });

    return <div className="account-factory">
        {error ? <div className="error-strip">{error}</div> : ""}

        <div className="field">
            <label>FULL NAME</label>
            <input onInput={() => update()} className="input" ref={refs.fullname} defaultValue={fullname} />
        </div>

        <div className="two-cols">
            <div>
                <div className="field">
                    <label>CONTACT NUMBER</label>
                    <input onInput={() => update()} className="input" ref={refs.contact} defaultValue={contact || ""} />
                </div>
            </div>

            <div>
                <div className="field">
                    <label>EMAIL</label>
                    <input onInput={() => update()} className="input" ref={refs.email} defaultValue={email || ""} />
                </div>
            </div>
        </div>
        <div className="two-cols">
            <div>
                <div className="field">
                    <label>USERNAME</label>
                    <input onInput={() => update()} disabled={modifying} className="input" ref={refs.username} defaultValue={username} />
                </div>
            </div>

            <div>
                <div className="field">
                    <label>PASSWORD</label>
                    <input onInput={() => update()} type="password" className="input" placeholder={modifying ? "Leave blank to ignore" : ""} ref={refs.password} defaultValue="" />
                </div>
            </div>
        </div>
        <div className="two-cols">
            <div>
                <div className="field">
                    <label>ROLE</label>
                    <Dropdown options={roleOptions} onSelect={(role) => setCurrentRole(role)} defaultValue={role} />
                </div>
            </div>

            <div>
                <div className="field">
                    <label>CONFIRM PASSWORD</label>
                    <input onInput={() => update()} className="input" type="password" placeholder={modifying ? "Leave blank to ignore" : ""} ref={refs.confirmPassword} defaultValue="" />
                </div>
            </div>
        </div>

        { ["lgu", "province"].includes(currentRole) ? <div className="lower">
            <div className="field">
                <label>LOCATION</label>
                {currentRole === "lgu" ? 
                    <LocationSelector values={{ lgu: currentLGU }} collection={collection} onChange={({lgu, province}) => { 
                        setCurrentRoleSpecific(lgu);
                        setLGU(lgu);
                        setProvince(province);
                    }} />
                : ""}
                {currentRole === "province" ?
                    <ProvinceSelector province={currentProvince} collection={collection} onChange={(province) => {
                        setCurrentRoleSpecific(province);
                        setProvince(province);
                    }} />
                : ""}
            </div>
        </div> : "" }

        {!modifying ? <div className="note"><b>NOTE</b>: Passwords MUST be remembered. It will never be displayed anywhere and cannot be retrieved again unless changed.</div> : "" }

        <Blocker active={saving}><center><LoadingAnimation />Saving account...</center></Blocker>
    </div>
}